import { useEffect } from "react";

/**
 * SocialPulse whitelists this frontend path as the OIDC redirect_uri.
 * We never touch the auth code here — just relay it straight to the
 * backend BFF callback, which performs the real token exchange.
 */
export default function SocialPulseCallback() {
  useEffect(() => {
    const backend = process.env.REACT_APP_BACKEND_URL;
    window.location.replace(`${backend}/api/v1/auth/socialpulse/callback${window.location.search}`);
  }, []);

  return (
    <div
      data-testid="socialpulse-callback-page"
      className="min-h-screen flex items-center justify-center bg-[color:var(--parchment)] text-[color:var(--ink)]"
    >
      <p className="font-sans-ui text-sm text-[color:var(--ink-soft)]">Completing SocialPulse sign-in…</p>
    </div>
  );
}
